import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import { ADS_STACK_QUERY } from '../../GraphQL/Queries/commerce/AdStackQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import { IAdStacksData } from '../../responseTypes/commerceResponse';

// import adStacksMock from './bingAdStacksMock';

export const getAdStacks = async (assetId = '') => {
  try {
    // const response: IAdStacksData = await graphQlRequest(ADS_STACK_QUERY, {
    //   assetId: '5-5-123456'
    // });
    const response: IAdStacksData = await graphQlRequest(
      ADS_STACK_QUERY,
      {
        assetId
      },
      GQL_QUERIES.ADS_STACK_QUERY
    );
    return response?.adStacks;
    // return adStacksMock;
  } catch (error) {
    console.error('Error while fetching ad stacks: ', error);
  }
};
